module.exports = function atan (arg) {
  //  discuss at: https://locutus.io/php/atan/
  // original by: Onno Marsman (https://twitter.com/onnomarsman)
  //   example 1: atan(8723321.4)
  //   returns 1: 1.5707962121596615

  return Math.atan(arg)
}
